export const bg = [
    'default'
  ];
  
  export const sources = {
    bg,
  }
  
  export default sources;